import React, { useState } from 'react';
import JobModal from './JobModal';

export default function StepExperience({ data, errors, update }) {
  const [showModal, setShowModal] = useState(false);
  const positions = data.positions || [];
  const selectedJob = positions.find(p => String(p.job_id) === String(data.position_applying));

  const handlePositionChange = (e) => {
    const jobId = e.target.value;
    update('position_applying', jobId);
    const job = positions.find(p => String(p.job_id) === jobId);
    update('job_title', job ? job.job_title.trim() : '');
  };

  return (
    <div>
      <h2 className="section-title">Experience</h2>

      <div className="form-group">
        <label>Position you're applying for</label>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <select className="form-control" style={{ flex: 1 }} value={data.position_applying} onChange={handlePositionChange}>
            <option value="">Choose your position</option>
            {positions.map(job => (
              <option key={job.job_id} value={job.job_id}>{job.job_title?.trim()}</option>
            ))}
          </select>
          {selectedJob && (
            <button type="button" className="btn btn-info btn-sm" onClick={() => setShowModal(true)}>Details</button>
          )}
        </div>
        {errors.position_applying && <div className="error-text">{errors.position_applying}</div>}
      </div>

      <div className="form-group">
        <label>Previous industry experience?</label>
        <select className="form-control" value={data.experience} onChange={e => update('experience', e.target.value)}>
          <option value="">Choose an option</option>
          <option value="No, I'm a fresher">No, I'm a fresher</option>
          <option value="3-6 months">3-6 months</option>
          <option value="1 year">1 year</option>
          <option value="2+ years">2+ years</option>
        </select>
        {errors.experience && <div className="error-text">{errors.experience}</div>}
      </div>

      <div className="form-group">
        <label>Education / Qualification</label>
        <select className="form-control" value={data.qualification} onChange={e => update('qualification', e.target.value)}>
          <option value="">Choose an option</option>
          <option value="Matric">Matric</option>
          <option value="Intermediate">Intermediate</option>
          <option value="Bachelors">Bachelors</option>
          <option value="Masters">Masters</option>
          <option value="Other">Other</option>
        </select>
        {errors.qualification && <div className="error-text">{errors.qualification}</div>}
      </div>

      <div className="form-group">
        <label>Expected Salary (PKR)</label>
        <input className="form-control" placeholder="e.g. 30000" value={data.expected_salary} onChange={e => update('expected_salary', e.target.value)} />
        {errors.expected_salary && <div className="error-text">{errors.expected_salary}</div>}
      </div>

      <div className="form-group">
        <label>How did you hear about us?</label>
        <select className="form-control" value={data.how_did_you_hear} onChange={e => update('how_did_you_hear', e.target.value)}>
          <option value="">Choose an option</option>
          <option value="Facebook">Facebook</option>
          <option value="Instagram">Instagram</option>
          <option value="LinkedIn">LinkedIn</option>
          <option value="Friend/Referral">Friend/Referral</option>
          <option value="Walk-in">Walk-in</option>
          <option value="Other">Other</option>
        </select>
        {errors.how_did_you_hear && <div className="error-text">{errors.how_did_you_hear}</div>}
      </div>

      {showModal && <JobModal job={selectedJob} onClose={() => setShowModal(false)} />}
    </div>
  );
}
